document.addEventListener("DOMContentLoaded", function () {
  const vanData = {
    VW: {
      Caddy: {
        years: ["2021-Onwards"],
        wheelbases: ["L1", "L2"]
      },
      "Transporter Panel Van": {
        years: ["2005-2024", "2025-Onwards"],
        wheelbases: ["SWB", "LWB"]
      },
      "Transporter Kombi/Crew Cab": {
        years: ["2005-2024", "2025-Onwards (with bulkhead)", "2025-Onwards (without bulkhead)"],
        wheelbases: ["SWB", "LWB"]
      }, 
      "ID Buzz Cargo": {
        years: ["2022-Onwards"],
        wheelbases: ["SWB"]
      },
      "Amarok II": {
        years: ["2022-Onwards"],
        wheelbases: ["Crew Cab"]
      },
    },
    Ford: {
      "Transit Custom": {
        years: ["2024-Onwards", "2012-2023"],
        wheelbases: ["SWB", "LWB"]
      },
      "Transit Custom Crew Cab": {
        years: ["2012-2023", "2024-Onwards"],
        wheelbases: ["SWB", "LWB"]
      },
      "Ranger": {
        years: ["2022-Onwards"],
        wheelbases: ["Crew Cab"]
      }
    },
    Kia: {
      "PV5 Cargo": {
        years: ["2025-Onwards"],
        wheelbases: ["L2"]
      }
    },
    Vauxhall: {
      "Vivaro Panel Van": {
        years: ["2014-2019", "2019-Onwards"],
        wheelbases: ["L1 SWB", "L2 LWB"]
      },
      "Vivaro Crew Cab": {
        years: ["2019-Onwards"],
        wheelbases: ["L1 SWB", "L2 LWB"]
      },
      Combo: {
        years: ["2018-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    },
    Citroën: {
      "Dispatch Panel Van": {
        years: ["2016-Onwards"],
        wheelbases: ["L1 MWB", "L2 LWB"]
      },
      "Dispatch Crew Cab": {
        years: ["2019-Onwards"],
        wheelbases: ["L1 MWB", "L2 LWB"]
      },
      Berlingo: {
        years: ["2018-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    },
    Peugeot: {
      "Expert Panel Van": {
        years: ["2016-Onwards"],
        wheelbases: ["L1 MWB", "L2 LWB"]
      },
      "Expert Crew Cab": {
        years: ["2019-Onwards"],
        wheelbases: ["L1 MWB", "L2 LWB"]
      },
      Partner: {
        years: ["2018-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    },
    Toyota: {
      "Proace Panel Van": {
        years: ["2016-Onwards"],
        wheelbases: ["L1 MWB", "L2 LWB"]
      },"Proace Crew Cab": {
        years: ["2019-Onwards"],
        wheelbases: ["L1", "L2"]
      },
      "Proace City": {
        years: ["2018-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    },
    Fiat: {
      "Scudo Panel Van": {
        years: ["2016-Onwards"],
        wheelbases: ["L1 SWB", "L2 LWB"]
      },"Scudo Crew Cab": {
        years: ["2019-Onwards"],
        wheelbases: ["L1 SWB", "L2 LWB"]
      },
      Doblo: {
        years: ["2018-Onwards"],
        wheelbases: ["L1", "L2"]
      },
      Talento: {
        years: ["2014-2021"],
        wheelbases: ["L1", "L2"]
      }
    },
    Mercedes: {
      Citan: {
        years: ["2022-Onwards"],
        wheelbases: ["L1", "L2"]
      },
      Vito: {
        years: ["2014-Onwards"],
        wheelbases: ["L1", "L2", "L3"]
      }
    },
    Nissan: {
      Townstar: {
        years: ["2022-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    },
    Renault: {
      Trafic: {
        years: ["2014-Onwards"],
        wheelbases: ["L1", "L2"]
      }
    }
  };

  const redirectUrls = {
    "vw-id-buzz-cargo-2022-onwards-swb": "/pages/vw-id-buzz-cargo-heights",
    "vw-caddy-2021-onwards-l1": "/pages/more-vans-coming-soon",
    "vw-caddy-2021-onwards-l2": "/pages/more-vans-coming-soon",
    "vw-transporter-panel-van-2025-onwards-swb": "/pages/vw-transporter-t7-2025-swb-heights",
    "vw-transporter-panel-van-2025-onwards-lwb": "/pages/vw-transporter-t7-2025-lwb-heights",
    "vw-transporter-panel-van-2005-2024-swb": "/pages/vw-transporter-2005-2024-swb-heights",
    "vw-transporter-panel-van-2005-2024-lwb": "/pages/vw-transporter-2005-2024-lwb-heights",
    "vw-transporter-kombi/crew-cab-2005-2024-swb": "/pages/vw-transporter-2005-2024-swb-kombi-heights",
    "vw-transporter-kombi/crew-cab-2005-2024-lwb": "/pages/vw-transporter-2005-2024-lwb-kombi-heights",
    "vw-transporter-kombi/crew-cab-2025-onwards-(with-bulkhead)-swb": "/pages/vw-transporter-kombi-swb-crew-cab-2024-heights",
    "vw-transporter-kombi/crew-cab-2025-onwards-(without-bulkhead)-swb": "/pages/vw-transporter-swb-kombi-2025-heights",
    "vw-transporter-kombi/crew-cab-2025-onwards-(with-bulkhead)-lwb": "/pages/vw-transporter-kombi-lwb-crew-cab-2024-heights",
    "vw-transporter-kombi/crew-cab-2025-onwards-(without-bulkhead)-lwb": "/pages/vw-transporter-lwb-kombi-2025-heights",
    "vw-amarok-ii-2022-onwards-crew-cab": "/collections/vw-amarok-2022-onwards",

  
    "ford-transit-custom-2024-onwards-swb": "/pages/ford-transit-custom-2024-heights",
    "ford-transit-custom-2024-onwards-lwb": "/pages/ford-transit-custom-lwb-2024-heights",
    "ford-transit-custom-crew-cab-2024-onwards-swb": "/pages/ford-transit-custom-swb-crew-cab-2024",
    "ford-transit-custom-crew-cab-2024-onwards-lwb": "/pages/ford-transit-custom-lwb-crew-cab-2024-heights",
    "ford-transit-custom-crew-cab-2012-2023-swb": "/pages/ford-transit-custom-crew-cab-2012-2023",
    "ford-transit-custom-crew-cab-2012-2023-lwb": "/pages/ford-transit-custom-crew-cab-lwb-2012-2023-heights",
    "ford-ranger-2022-onwards-crew-cab": "/collections/ford-ranger-2022-onwards",

    "kia-pv5-cargo-2025-onwards-l2": "/pages/kia-pv5-cargo-l2-heights",

    "vauxhall-vivaro-panel-van-2019-onwards-l1-swb": "/pages/vauxhall-vivaro-l1-2019",
    "vauxhall-vivaro-panel-van-2019-onwards-l2-lwb": "pages/vauhall-vivaro-l2-2019",
    "vauxhall-vivaro-2014-2019-l1": "/pages/more-vans-coming-soon",
    "vauxhall-vivaro-2014-2019-l2": "/pages/more-vans-coming-soon",
    "vauxhall-combo-2018-onwards-l1": "/pages/more-vans-coming-soon",
    "vauxhall-combo-2018-onwards-l2": "/pages/more-vans-coming-soon",

    "citroën-dispatch-panel-van-2016-onwards-l1-mwb": "/pages/citroen-dispatch-l1-2016",
    "citroën-dispatch-panel-van-2016-onwards-l2-lwb": "pages/citroen-dispatch-l2-2016",
    "citroën-berlingo-2018-onwards-l1": "/pages/more-vans-coming-soon",
    "citroën-berlingo-2018-onwards-l2": "/pages/more-vans-coming-soon",

    "peugeot-expert-panel-van-2016-onwards-l1-mwb": "/pages/peugeot-expert-l1-2016",
    "peugeot-expert-panel-van-2016-onwards-l2-lwb": "pages/peugeot-expert-l2-2016",
    "peugeot-partner-2018-onwards-l1": "/pages/more-vans-coming-soon",
    "peugeot-partner-2018-onwards-l2": "/pages/more-vans-coming-soon",

    "toyota-proace-panel-van-2016-onwards-l1-mwb": "/pages/toyota-proace-l1-2016",
    "toyota-proace-panel-van-2016-onwards-l2-lwb": "pages/toyota-proace-l2-2016",
    "toyota-proace-city-2018-onwards-l1": "/pages/more-vans-coming-soon",
    "toyota-proace-city-2018-onwards-l2": "/pages/more-vans-coming-soon",

    "fiat-scudo-panel-van-2016-onwards-l1-swb": "/pages/fiat-scudo-l1-2016",
    "fiat-scudo-panel-van-2016-onwards-l2-lwb": "pages/fiat-scudo-l2-2016",
    "fiat-doblo-2018-onwards-l1": "/pages/more-vans-coming-soon",
    "fiat-doblo-2018-onwards-l2": "/pages/more-vans-coming-soon",
    "fiat-talento-2014-2021-l1": "/pages/more-vans-coming-soon",
    "fiat-talento-2014-2021-l2": "/pages/more-vans-coming-soon",

    "mercedes-citan-2022-onwards-l1": "/pages/more-vans-coming-soon",
    "mercedes-citan-2022-onwards-l2": "/pages/more-vans-coming-soon",
    "mercedes-vito-2014-onwards-l1": "/pages/more-vans-coming-soon",
    "mercedes-vito-2014-onwards-l2": "/pages/more-vans-coming-soon",
    "mercedes-vito-2014-onwards-l3": "/pages/more-vans-coming-soon",

    "nissan-townstar-2022-onwards-l1": "/pages/more-vans-coming-soon",
    "nissan-townstar-2022-onwards-l2": "/pages/more-vans-coming-soon",

    "renault-trafic-2014-onwards-l1": "/pages/more-vans-coming-soon",
    "renault-trafic-2014-onwards-l2": "/pages/more-vans-coming-soon"
  };

  const makeSelect = document.getElementById("make");
  const modelSelect = document.getElementById("model");
  const yearSelect = document.getElementById("year");
  const wheelbaseSelect = document.getElementById("wheelbase");
  const form = document.getElementById("van-selector-form");

  function populate(select, options, placeholder) {
    select.innerHTML = "";
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    options.forEach(opt => {
      const option = document.createElement("option");
      option.value = opt;
      option.textContent = opt.charAt(0).toUpperCase() + opt.slice(1);
      select.appendChild(option);
    });
  }

  populate(makeSelect, Object.keys(vanData), "Select Make");

  makeSelect.addEventListener("change", () => {
    const selectedMake = makeSelect.value;
    if (!selectedMake || !vanData[selectedMake]) return;

    const models = Object.keys(vanData[selectedMake]);
    populate(modelSelect, models, "Select Model");
    populate(yearSelect, [], "Select Year");
    populate(wheelbaseSelect, [], "Select Wheelbase");

    modelSelect.disabled = false;
    yearSelect.disabled = true;
    wheelbaseSelect.disabled = true;
  });

  modelSelect.addEventListener("change", () => {
    const make = makeSelect.value;
    const model = modelSelect.value;
    if (!make || !model || !vanData[make][model]) return;

    const { years, wheelbases } = vanData[make][model];
    populate(yearSelect, years, "Select Year");
    populate(wheelbaseSelect, wheelbases, "Select Wheelbase");

    yearSelect.disabled = false;
    wheelbaseSelect.disabled = false;
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const make = makeSelect.value;
    const model = modelSelect.value;
    const year = yearSelect.value;
    const wheelbase = wheelbaseSelect.value;

    if (!make || !model || !year || !wheelbase) return;

    const key = `${make}-${model}-${year}-${wheelbase}`
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/–/g, "-");

    const url = redirectUrls[key] || "/pages/more-vans-coming-soon";
    window.location.href = url;
  });
});